"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderServiceTask = void 0;
const typeorm_1 = require("typeorm");
const OrderTask_1 = require("./OrderTask");
const Language_1 = require("../../language/entity/Language");
let OrderServiceTask = class OrderServiceTask extends OrderTask_1.OrderTask {
    constructor(init) {
        super();
        if (init) {
            Object.assign(this, init);
        }
    }
};
exports.OrderServiceTask = OrderServiceTask;
__decorate([
    (0, typeorm_1.ManyToOne)(() => Language_1.Language, { nullable: true }),
    __metadata("design:type", Language_1.Language)
], OrderServiceTask.prototype, "targetLanguage", void 0);
__decorate([
    (0, typeorm_1.RelationId)((o) => o.targetLanguage),
    __metadata("design:type", String)
], OrderServiceTask.prototype, "targetLanguageId", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => OrderTask_1.OrderTask, (ost) => ost.parentTask),
    __metadata("design:type", Array)
], OrderServiceTask.prototype, "stepTasks", void 0);
exports.OrderServiceTask = OrderServiceTask = __decorate([
    (0, typeorm_1.ChildEntity)('service-task'),
    __metadata("design:paramtypes", [Object])
], OrderServiceTask);
